
import { CommonModule, DatePipe } from '@angular/common';
import { Component,  Input, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'date-picker',
    template: `
<div class="bounding_box">
  <div class="date_picker" [ngClass]="{no_date: !pickedDate}" (click)="picker.open()">
    <mat-datepicker-toggle color="primary" [for]="picker"></mat-datepicker-toggle>
    {{pickedDate ? (pickedDate | date: (byMonth ? 'MMMM y' : 'EEEE d MMMM y')) : 'Select date ...'}}
  </div>
  <mat-form-field class="general date_field" style="height: 1px; visibility: hidden;">
    <input hidden style="display: none;" matInput id="date" name="date" #pickerInput [matDatepicker]="picker" (dateChange)="changeDate($event.value)" [(ngModel)]="pickedDate">
    <mat-datepicker #picker [startView]="byMonth ? 'multi-year' : 'month'"  (monthSelected)="!byMonth ? null : changeDate($event, picker)"></mat-datepicker>
  </mat-form-field>
</div>
`,
    styles: [`
.date_picker { position: static; padding: 4px 0; cursor: pointer; display: flex; align-items: center; }
.date_picker mat-datepicker-toggle { color: #5A97A6; }
.bounding_box { display: flex; height: 41px; flex-direction: column; }
date_picker .mat-mdc-form-field-infix {display: none !important;}
::ng-deep date-picker {  margin: 0 0 0px -4px; }
::ng-deep mat-datepicker-toggle .mat-icon-button { height: 24px; width: 24px; }

`],
      imports: [MatDatepickerModule, DatePipe, FormsModule, CommonModule, MatDatepickerModule, MatFormFieldModule, MatInputModule],
    standalone: true,
})
export class DatePickerComponent {
  @Input() pickedDate: Date | number
  @Input() byMonth = false
  @Output() onDateChange: EventEmitter<Date> = new EventEmitter()

  changeDate(date: Date, datePicker: MatDatepicker<any> = null) {
    const roundedDate = date.setHours(0, 0, 0, 0)
    this.onDateChange.emit(new Date(roundedDate))
    if (datePicker) datePicker.close()
  }


}
